import { ISort } from '~/utils/sort/types';

interface ICell {
  id: string;
  label: string;
  useSort: boolean;
  width?: number;
  align?: any;
}

export const headCells: ICell[] = [
  {
    id: 'name',
    label: 'Name',
    useSort: true,
  },
  {
    id: 'typeId',
    label: 'Type',
    useSort: true,
  },
  {
    id: 'createdByUserFullName',
    label: 'Author',
    useSort: true,
  },
  {
    id: 'actions',
    label: '',
    useSort: false,
    width: 120,
    align: 'center',
  },
];

export const initialSort: ISort = {
  orderBy: 'name',
  isDescending: false,
};

export default {};
